import { computed, ComputedRef } from 'vue'

import { ModelAnswer } from '@/domain/entities/modelAnswer/modelAnswer'
import { ProgramLanguageType } from '@/domain/value_objects/language/programLanguageType'
import { ModelAnswerListViewModel } from '@/presentation/viewmodels/modelAnswer/modelAnswerListViewModel'

export class ModelAnswerListPresenter {
  private viewModel: ModelAnswerListViewModel

  constructor(viewModel: ModelAnswerListViewModel) {
    this.viewModel = viewModel
  }

  get modelAnswerList(): ComputedRef<{ [judgeId: number]: ModelAnswer }> {
    return this.viewModel.modelAnswerList
  }

  get loading(): ComputedRef<boolean> {
    return this.viewModel.loading
  }

  get error(): ComputedRef<Error | null> {
    return this.viewModel.error
  }

  get hasModelAnswerInList(): ComputedRef<boolean> {
    return computed(() => Object.keys(this.viewModel.modelAnswerList.value).length > 0)
  }

  async fetchModelAnswerList(
    problemId: string,
    programLanguage: ProgramLanguageType,
    pageIndex: number
  ): Promise<void> {
    await this.viewModel.fetchModelAnswerList(problemId, programLanguage, pageIndex)
  }
}
